import type { AxiosInstance } from 'axios';
import { Kit, KitList } from './types';
import { PaginateOptions } from '../types';

export class KitService {
  instance: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  async list(options: PaginateOptions): Promise<KitList> {
    const response = await this.instance.get<KitList>('/kits', {
      params: options,
    });
    return response.data;
  }

  async getById({ id }: { id: number }): Promise<Kit> {
    const response = await this.instance.get<Kit>(`/kits/${id}`, {
      params: {
        dbOnly: false,
      },
    });
    return response.data;
  }
}
